import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
import formatDate from "../../../components/utils/DateFormatter";

const GetAllRemittance = () => {
    const [remittance, setRemittance] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [confirmationLoading, setConfirmationLoading] = useState(false);
    const { permissions } = useContext(AuthContext);
    // console.log("all permission", permissions);
    const [updatingIncentive, setUpdatingIncentive] = useState(false);
    const [branchOpe, setBranchOpe] = useState([]);
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [filterLoading, setFilterLoading] = useState(false);
    const [clearFilterLoading, setClearFilterLoading] = useState(false);

    const [filters, setFilters] = useState({
        per_page: 20,
        page: 1,
        branch_id: "",
        status: "",
        type: "",
        start_date: "",
        end_date: "",
    });

    const [pagination, setPagination] = useState({
        total: 0,
        currentPage: 1,
        perPage: 20,
    });

    const navigate = useNavigate();
    // const axios = AxiosApiCall();

    const fetchAllbranchList = async () => {
        setLoading(true);
        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            // console.log("this is the token from branch", token);
            if (!token) {
                throw new Error("No access token found.");
            }
            const response = await axios.get(ApiServices.getAllBranchOperations, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            });

            const { status, message, data } = response.data;
            // console.log("this is all branch opeartions list", data);

            if (status === 200) {
                const sortedData = data
                    .slice()
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

                setBranchOpe(sortedData);
                toast.success(message, { toastId: "product-fetch-success" });
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    const fetchAllRemittance = async (payload = filters) => {
        setLoading(true);
        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) throw new Error("No access token found.");

            const response = await axios.get(ApiServices.getAllRemittance, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                params: payload,
                withCredentials: true,
            });

            const { status, message, data } = response.data;
            if (status === 200 && data) {
                // setRemittance(data.remittances.slice().reverse() || []);
                setRemittance(data.remittances);
                setPagination({
                    total: data.total || 0,
                    currentPage: data.current_page || 1,
                    perPage: data.per_page || 20,
                });
                toast.success(message, { toastId: "remittance-fetch-success" });
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchAllbranchList();
        fetchAllRemittance();
    }, []);

    const isAnyFilterFilled = () => {
        return Object.values(filters).some(
            (value) => value !== "" && value !== null
        );
    };


    const handleClearFilters = async () => {
        const defaultFilters = {
            per_page: 20,
            page: 1,
            branch_id: "",
            status: "",
            type: "",
            start_date: "",
            end_date: "",
        };

        setFilters(defaultFilters);
        setClearFilterLoading(true);
        await fetchAllRemittance(defaultFilters);
        setClearFilterLoading(false);
    };



    const handleFilterClick = async () => {
        if (!isAnyFilterFilled()) return;
        setFilterLoading(true);
        await fetchAllRemittance(filters);
        setFilterLoading(false);
    };

    // Handle pagination
    const handlePageChange = (page) => {
        const newFilters = {
            ...filters,
            page: page
        };
        setFilters(newFilters);
        fetchAllRemittance(newFilters);
    };

    // Handle per page change
    const handlePerRowsChange = async (newPerPage, page) => {
        const newFilters = {
            ...filters,
            page: page,
            per_page: newPerPage
        };
        setFilters(newFilters);
        await fetchAllRemittance(newFilters);
    };



    const ExpandableComponent = ({ data }) => (
        <div className="flex justify-start p-4 relative">

            {permissions.some(permission => permission.name === 'branch.remittance.view') && (
                <div className="mx-2 my-2 group relative">
                    <Link
                        to="/operations/branch/remittance/details"
                        state={{ data }}
                    >
                        <Eye className="w-5 h-5 text-dash4 " />
                    </Link>
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block  text-darkGreen3 text-xs px-2 py-1 rounded">
                        Details
                    </div>
                </div>
            )}
        </div>
    );


    const columns = [
        {
            name: "Remittance No",
            selector: (row) => row.remittance_number ? row.remittance_number : "NOT AVAILABLE",
            sortable: true,
            width: "220px",
        },
        {
            name: "Branch",
            selector: (row) => row.branch?.name.toUpperCase() || "NOT AVAILABLE",
            sortable: true,
            width: "200px",
        },
        {
            name: "Type",
            selector: (row) => row.type_label ? row.type_label.toUpperCase() : "NOT AVAILABLE",
            sortable: true,
            width: "200px",
        },
        {
            name: "Amount",
            selector: (row) => CurrencyFormatter(row.amount) ? row.amount : "0:00",
            sortable: true,
            width: "160px",
        },
        {
            name: "Status",
            selector: (row) => row.status ? row.status : "NOT AVAILABLE",
            sortable: true,
            width: "160px",
            cell: (row) => (
                <span
                    className={
                        row.status === "pending"
                            ? "text-orange1"
                            : row.status === "completed"
                                ? "text-green-600"
                                : row.status === "rejected"
                                    ? "text-red-600"
                                    : "text-darkGreen3"
                    }
                >
                    {row.status.toUpperCase()}
                </span>
            ),
        },
        {
            name: "Description",
            selector: (row) => row.description ? row.description.toUpperCase() : "NOT AVAILABLE",
            wrap: true,
            width: "300px",
        },
        {
            name: "Date Submitted",
            selector: (row) => formatDate(row.submitted_at) ? formatDate(row.submitted_at) : "NOT AVAILABLE",
            width: "200px",
        },
    ];
    const filteredItems = remittance.filter((item) =>
        Object.keys(item).some((key) =>
            item[key]?.toString().toLowerCase().includes(filterText.toLowerCase())
        )
    );

    const data = filteredItems.map((remittance) => ({
        remittance_number: remittance.remittance_number || "NOT AVAILABLE",
        reference: remittance.reference || "NOT AVAILABLE",
        branch_name: remittance.branch?.name || "NOT AVAILABLE",
        type: remittance.type_label || "NOT AVAILABLE",
        amount: remittance.amount || 0,
        status: remittance.status || "NOT AVAILABLE",
        description: remittance.description || "NOT AVAILABLE",
        submitted_at: remittance.submitted_at || "NOT AVAILABLE",
        approved_at: remittance.approved_at || "NOT AVAILABLE",
        completed_at: remittance.completed_at || "NOT AVAILABLE",
        created_at: remittance.created_at || "NOT AVAILABLE",
        initiator: remittance.initiator?.fullname || "NOT AVAILABLE",
        approver: remittance.approver?.fullname || "NOT AVAILABLE",
    }));




    return (
        <MainLayouts>
            <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                <section
                    className="w-full pr-[3%] pt-3 my-3"
                    style={{ backgroundColor: "#F7F7F7" }}
                >
                    <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                        <ol className="list-none p-0 inline-flex mb-2">
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Operations
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Remittance
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-orange1">List</p>
                            </li>
                        </ol>
                    </nav>
                </section>


                <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
                    <div className="flex flex-wrap gap-3 mb-4">
                        <select
                            className="border rounded px-3 py-2 border-lGrey"
                            value={filters.branch_id}
                            onChange={(e) =>
                                setFilters({ ...filters, branch_id: e.target.value })
                            }
                        >
                            <option value="">All Branches</option>
                            {branchOpe.map((branch) => (
                                <option key={branch.id} value={branch.id}>
                                    {branch.name}
                                </option>
                            ))}
                        </select>

                        <select
                            className="border rounded px-3 py-2 border-lGrey"
                            value={filters.status}
                            onChange={(e) =>
                                setFilters({ ...filters, status: e.target.value })
                            }
                        >
                            <option value="">All Status</option>
                            <option value="pending">Pending</option>
                            <option value="completed">Completed</option>
                            <option value="rejected">Rejected</option>
                        </select>

                        <select
                            className="border rounded px-3 py-2 border-lGrey"
                            value={filters.type}
                            onChange={(e) => setFilters({ ...filters, type: e.target.value })}
                        >
                            <option value="">All Types</option>
                            <option value="branch_initiated">Branch Remittance</option>
                            <option value="admin_deduction">Admin Deduction</option>
                        </select>

                        <input
                            type="date"
                            className="border rounded px-3 py-2 border-lGrey"
                            value={filters.start_date}
                            onChange={(e) =>
                                setFilters({ ...filters, start_date: e.target.value })
                            }
                        />
                        <input
                            type="date"
                            className="border rounded px-3 py-2 border-lGrey"
                            value={filters.end_date}
                            onChange={(e) =>
                                setFilters({ ...filters, end_date: e.target.value })
                            }
                        />

                        <button
                            onClick={handleFilterClick}
                            className="bg-darkGreen3 text-lGrey px-4 py-2 rounded disabled:opacity-50"
                            disabled={!isAnyFilterFilled() || filterLoading}
                        >
                            {filterLoading ? "Filtering..." : "Filter"}
                        </button>

                        {isAnyFilterFilled() && (
                            <button
                                onClick={handleClearFilters}
                                className="bg-orange1 text-lGrey px-4 py-2 rounded hover:bg-orange1 transition-colors"
                                disabled={clearFilterLoading}
                            >
                                {clearFilterLoading ? "Clearing..." : "Clear Filters"}
                            </button>
                        )}
                    </div>
                </div>
                {loading ? (
                    <Spinner />
                ) : (
                    <DataTable
                        columns={columns}
                        data={remittance}
                        pagination
                        highlightOnHover
                        striped
                        customStyles={CustomStyles}
                        noDataComponent={<div>No remittance found</div>}
                        expandableRows
                        expandableRowsComponent={(props) => (
                            <ExpandableComponent data={props.data} />
                        )}
                    />
                )}
            </div>
        </MainLayouts>
    );
};

export default GetAllRemittance;
